/* globals Forms */

window['passwords#edit'] = function () {
  Forms.initPasswordChecker()
}
